/**
 * Off-site links open in a new tab: any link to another site (certificates, the GOTS database, booking pages,
 * partner sites) gets target="_blank" and rel="noopener". Links within omimattress.com, the shop's other domains
 * and its subdomains stay in the same tab. Runs on load and on click, so links added later are covered too.
 */
(() => {
  const local = location.hostname.replace(/^www\./, '');

  /** @param {HTMLAnchorElement} a */
  const isExternal = (a) => {
    if (!/^https?:$/.test(a.protocol)) return false;
    const host = a.hostname.replace(/^www\./, '');
    return host !== local && !host.endsWith('.' + local) && !host.endsWith('omimattress.com') && !host.endsWith('myshopify.com');
  };

  /** @param {HTMLAnchorElement} a */
  const mark = (a) => {
    if (a.target || !isExternal(a)) return;
    a.target = '_blank';
    const rel = new Set((a.rel || '').split(/\s+/).filter(Boolean));
    rel.add('noopener');
    a.rel = [...rel].join(' ');
  };

  const markAll = () => document.querySelectorAll('a[href]').forEach((a) => mark(/** @type {HTMLAnchorElement} */ (a)));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markAll);
  else markAll();

  document.addEventListener(
    'click',
    (event) => {
      const a = /** @type {HTMLElement} */ (event.target).closest?.('a[href]');
      if (a) mark(/** @type {HTMLAnchorElement} */ (a));
    },
    true
  );
})();
